<template>
  <div style="padding: 15px">
    <a-row>
      <a-col :span="24" :lg="24" :xl="24" class="mb-24">
        <a-radio-group
          v-model:value="SelType"
          button-style="solid"
          @change="SelTypeChange"
          size="small"
        >
          <a-radio-button value="0">拆分</a-radio-button>
          <a-radio-button value="1">合并</a-radio-button>
          <a-radio-button value="2">分红</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24" :lg="24" :xl="24" class="mb-24">
        <el-table
          :data="etfErrDate"
          v-loading="loading"
          :stripe="true"
          style="border: 1px solid #e4e7ed"
        >
          <el-table-column prop="etfDm" label="ETF代码" width="100" />
          <el-table-column prop="etfName" label="ETF名称" />
          <el-table-column prop="infoTime" label="异常日期" width="150" />
          <el-table-column prop="dividend" label="分红" />
          <el-table-column prop="marketTime" label="上市时间" width="150" />
        </el-table>
        <div class="PageCom">
          <el-pagination
            background
            :current-page="Page.index"
            :page-sizes="Page.sizes"
            :page-size="Page.size"
            :total="Page.total"
            layout="sizes, total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getEtfTop } from "@/api/charts";
export default {
  data() {
    return {
      etfErrDate: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      SelType: "0",
      loading: false,
    };
  },
  created() {
    this.GetEtfTopData();
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetEtfTopData();
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetEtfTopData();
    },
    GetEtfTopData() {
      this.loading = true;
      getEtfTop(this.Page.index, this.Page.size, this.SelType).then((res) => {
        if (res.code == 0) {
          const list = res.data.list || [];
          // 转换infoTime格式
          this.etfErrDate = list.map((item) => {
            if (item.infoTime) {
              const year = item.infoTime.toString().substring(0, 4);
              const month = item.infoTime.toString().substring(4, 6);
              const day = item.infoTime.toString().substring(6, 8);

              const year1 = item.marketTime.toString().substring(0, 4);
              const month1 = item.marketTime.toString().substring(4, 6);
              const day1 = item.marketTime.toString().substring(6, 8);
              return {
                ...item,
                infoTime: `${year}年${month}月${day}日`,
                marketTime: `${year1}年${month1}月${day1}日`,
              };
            }
          });
          this.Page.total = res.data.total || 0;
        }
      });
      this.loading = false;
    },
    SelTypeChange() {
      this.GetEtfTopData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>